export default __webpack_public_path__ + "assets/403.5ce621b6.svg";